import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBulletList = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.79167 7.125C6.28541 7.125 5.875 7.53541 5.875 8.04167C5.875 8.54793 6.28541 8.95833 6.79167 8.95833C7.29793 8.95833 7.70833 8.54793 7.70833 8.04167C7.70833 7.53541 7.29793 7.125 6.79167 7.125ZM4.375 8.04167C4.375 6.70698 5.45698 5.625 6.79167 5.625C8.12636 5.625 9.20833 6.70698 9.20833 8.04167C9.20833 9.37636 8.12636 10.4583 6.79167 10.4583C5.45698 10.4583 4.375 9.37636 4.375 8.04167ZM11.0417 7.29167H19.625V8.79167H11.0417V7.29167ZM6.79167 15.0417C6.2854 15.0417 5.875 15.4521 5.875 15.9583C5.875 16.4646 6.2854 16.875 6.79167 16.875C7.29794 16.875 7.70833 16.4646 7.70833 15.9583C7.70833 15.4521 7.29794 15.0417 6.79167 15.0417ZM4.375 15.9583C4.375 14.6236 5.45699 13.5417 6.79167 13.5417C8.12635 13.5417 9.20833 14.6236 9.20833 15.9583C9.20833 17.2931 8.12635 18.375 6.79167 18.375C5.45699 18.375 4.375 17.2931 4.375 15.9583ZM11.0417 15.2083H19.625V16.7083H11.0417V15.2083Z",
		fill: "currentColor"
	})]
});
export default SvgBulletList;
